import Vue from 'vue';
export default {
    setList(state, list) {
        state.list = list;
    },
    setLastMessage(state, {index, message}) {
        if (index >= 0) {
            const room = state.list[index];
            room.lastMessage = message;
            room.unreadCount = (room.unreadCount || 0) + 1;
            Vue.set(state.list, index, room);
        }
    },
    setRoom(state, {index, room}) {
        if (index >= 0) {
            Vue.set(state.list, index, room);
        }
    },
    addRoom(state, room) {
        const index = state.list.findIndex(item => item.id == room.id);
        if (index < 0) {
            state.list.push(room);
        }
        else {
            Vue.set(state.list, index, room);
        }
    },
    removeRoom(state, index) {
        if (index >= 0) {
            state.removed.push(state.list[index]);
            Vue.delete(state.list, index);
        }
    }
}